// src/features/auth/hooks/useAuthInit.ts
import { useEffect } from 'react';
import { useAppDispatch } from '@/shared/lib/hooks/useAppDispatch';
import { loginSuccess, logout } from '@/features/auth/model/authSlice';
import { passQuestionnaire, fetchLatestRiskResult } from '@/features/questionnaire/model/questionnaireSlice';
import { getProfile } from '@/features/auth/api/authApi';
import {axiosInstance} from "@/shared/api/axiosInstance";
import {fetchLatestTrainingPlan} from "@/features/training/model/trainingSlice";
import {fetchLatestNutritionPlan} from "@/features/nutrition/model/nutritionSlice";

export const useAuthInit = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (!token) return;

        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const fetchSession = async () => {
            try {
                const profile = await getProfile();

                dispatch(
                    loginSuccess({
                        token,
                        user: {
                            id: profile.id,
                            firstName: profile.first_name,
                            lastName: profile.surname,
                            email: profile.email,
                            phone: profile.phone || '',
                            secondName: profile.second_name,
                            birthDate: profile.birth_date,
                            insuranceCompany: profile.insurance_company,
                        },
                    })
                );


                if (profile.is_actual) {
                    dispatch(passQuestionnaire());
                    await dispatch(fetchLatestRiskResult());
                    await dispatch(fetchLatestTrainingPlan());
                    await dispatch(fetchLatestNutritionPlan());
                }
            } catch (e) {
                console.warn('Ошибка при восстановлении сессии, выходим');
                dispatch(logout());
            }
        };

        fetchSession();
    }, []);
};
